<template>
  <div class="container-fluid cards-pf full-height">
    <div v-if="$apollo.loading">
      <div style="margin-top: 10%;" class="text-center">
        <div class="spinner" />
        <strong>กำลังโหลด..</strong>
      </div>
    </div>
    <div v-else class="row row-cards-pf" style="padding-bottom: 20px;">
      <div class="col-md-9">
        <div class="card-pf" style="height: 100%; margin-bottom: 20px;">
          <div class="card-pf-heading">
            <h2 class="card-pf-title">
              เอกสารรายละเอียดโครงการ
            </h2>
          </div>
          <div style="height: 100vh;" class="card-pf-body">
            <iframe
              v-if="!projectProposal.signedDoc"
              :src="`https://docs.google.com/viewerng/viewer?url=https://osda.dev.devcrew.co.th/api/pdf/project-proposal?id=${$route.params.id}&embedded=true`"
              frameborder="0"
              height="100%"
              width="100%"
            />
            <iframe
              v-else
              :src="`https://docs.google.com/viewerng/viewer?url=https://osda.dev.devcrew.co.th/api${projectProposal.signedDoc}&embedded=true`"
              frameborder="0"
              height="100%"
              width="100%"
            />
          </div>
          <!-- <div class="card-pf-body">
              <div class="row project-info">
                <div class="col-xs-3">
                  <strong>1. ชื่อโครงการ</strong>
                </div>
                <div class="col-xs-4">
                  <span>{{ projectProposal.name }}</span>
                </div>
              </div>
              <div class="row project-info">
                <div class="col-xs-3">
                  <strong>2. หน่วยงานที่รับผิดชอบ</strong>
                </div>
                <div class="col-xs-4">
                  <span>{{ projectProposal.type }}</span>
                </div>
              </div>
              <div class="row project-info">
                <div class="col-xs-3">
                  <strong>3. ผู้รับผิดชอบโครงการ</strong>
                </div>
                <div class="col-xs-3">
                  <span>{{ projectProposal.responsiblePerson.name }}</span>
                </div>
                <div class="col-xs-1 text-right">
                  <strong>โทรศัพท์</strong>
                </div>
                <div class="col-xs-3">
                  <span>{{ projectProposal.responsiblePerson.tel }}</span>
                </div>
              </div>
              <div class="row project-info">
                <div class="col-xs-3">
                  <strong>4.อาจารย์ที่ปรึกษา</strong>
                </div>
                <div class="col-xs-3">
                  <span>{{ projectProposal.advisor.name }}</span>
                </div>
                <div class="col-xs-1 text-right">
                  <strong>โทรศัพท์</strong>
                </div>
                <div class="col-xs-3">
                  <span>{{ projectProposal.advisor.tel }}</span>
                </div>
              </div>
              <div class="row project-info">
                <div class="col-xs-3">
                  <strong>5.ประเภทกิจกรรม</strong>
                </div>
                <div class="col-xs-4">
                  <span>{{ projectProposal.type }}</span>
                </div>
              </div>
              <div class="form-group-title project-info">6. ลักษณะกิจกรรมที่บ่งชี้ถึงอัตลักษณ์สถาบัน</div>
              <div class="row project-info">
                <div class="col-xs-3">
                  <strong class="control-label">ซื่อสัตย์</strong>
                </div>
                <div class="col-xs-8">
                  <span>{{ projectProposal.typeCharacteristics[0] }}</span>
                </div>
              </div>
              <div class="row project-info">
                <div class="col-xs-3">
                  <strong class="control-label">ใฝ่รู้</strong>
                </div>
                <div class="col-xs-8">
                  <span>{{ projectProposal.typeCharacteristics[1] }}</span>
                </div>
              </div>
              <div class="row project-info">
                <div class="col-xs-3">
                  <strong class="control-label">สู้งาน</strong>
                </div>
                <div class="col-xs-8">
                  <span>{{ projectProposal.typeCharacteristics[2] }}</span>
                </div>
              </div>
              <div class="row project-info">
                <div class="col-xs-3">
                  <strong>7. หลักการและเหตุผล</strong>
                </div>
                <div class="col-xs-8">
                  <span>{{ projectProposal.background }}</span>
                </div>
              </div>
              <div class="row project-info">
                <div class="col-xs-3">
                  <strong>8. จุดมุ่งหมาย/วัตถุประสงค์</strong>
                </div>
                <div class="col-xs-8">
                  <span>{{ projectProposal.objectives }}</span>
                </div>
              </div>
              <div class="row project-info">
                <div class="col-xs-3">
                  <strong>9. ลักษณะการดำเนินงาน ปฏิบัติงาน และเป้าหมาย</strong>
                </div>
                <div class="col-xs-8">
                  <span>{{ projectProposal.objectives }}</span>
                </div>
              </div>
              <div class="row project-info">
                <div class="col-xs-3">
                  <strong>10. สถานที่จัดโครงการ</strong>
                </div>
                <div class="col-xs-8">
                  <span>{{ projectProposal.venue }}</span>
                </div>
              </div>
              <div class="row project-info">
                <div class="col-xs-3">
                  <strong>11. วันที่ดำเนินโครงการ</strong>
                </div>
                <div class="col-xs-8">
                  <span>{{ projectProposal.heldOn }}</span>
                </div>
              </div>
              <div class="row project-info">
                <div class="col-xs-3">
                  <strong>12. ผู้เข้าร่วมโครงการ</strong>
                </div>
                <div class="col-xs-8">
                  <div class="row">
                    <div class="col-xs-4">
                      อาจารย์ {{ projectProposal.attendee.instructor | numFormat }} คน
                    </div>
                    <div class="col-xs-4">
                      นักศึกษา {{ projectProposal.attendee.student | numFormat }} คน
                    </div>
                    <div class="col-xs-4">
                      ประชาชนกลุ่มเป้าหมาย {{ projectProposal.attendee.individual | numFormat }} คน
                    </div>
                  </div>
                </div>
              </div>
              <div class="row project-info">
                <div class="col-xs-3">
                  <strong>13. ขั้นตอนการดำเนินงาน</strong>
                </div>
                <div class="col-xs-8">
                  <span>{{ projectProposal.procedures }}</span>
                </div>
              </div>
              <div class="row project-info">
                <div class="col-xs-3">
                  <strong>14. ผลที่คาดว่าจะได้รับ</strong>
                </div>
                <div class="col-xs-8">
                  <span>{{ projectProposal.expectedOutcome }}</span>
                </div>
              </div>
              <div class="form-group-title project-info">15. งบประมาณการดำเนินงาน</div>
              <div class="row project-info">
                <div class="col-xs-3">
                  <strong class="control-label">เงินสนับสนุนกิจกรรมนักศึกษาจากสถาบันฯ</strong>
                </div>
                <div class="col-xs-8">
                  <span>จำนวน {{ projectProposal.budget.osda | numFormat('0,0.00') }} บาท ({{ projectProposal.budget.osda | thaibahttext }})</span>
                </div>
              </div>
              <div class="row project-info">
                <div class="col-xs-3">
                  <strong class="control-label">งบอื่นๆ</strong>
                </div>
                <div class="col-xs-8">
                  <span>จำนวน {{ projectProposal.budget.other | numFormat('0,0.00') }} บาท ({{ projectProposal.budget.other | thaibahttext }})</span>
                </div>
              </div>
              <div class="row project-info">
                <div class="col-xs-3">
                  <strong class="control-label">งบสนับสนุนจาก บริษัท/ห้าง/ร้าน</strong>
                </div>
                <div class="col-xs-8">
                  <span>จำนวน {{ projectProposal.budget.sponsors | numFormat('0,0.00') }} บาท ({{ projectProposal.budget.sponsors | thaibahttext }})</span>
                </div>
              </div>
              <div class="form-group-title project-info">ประกอบด้วยรายจ่ายดังต่อไปนี้</div>
              <div class="row project-info">
                <div class="col-xs-3">
                  <strong class="control-label">15.1 ค่าอาหารนักศึกษา</strong>
                </div>
                <div class="col-xs-8">
                  <span>จำนวน {{ projectProposal.plannedBudget.meal | numFormat('0,0.00') }} บาท ({{ projectProposal.plannedBudget.meal | thaibahttext }})</span>
                </div>
              </div>
              <div class="row project-info">
                <div class="col-xs-3">
                  <strong class="control-label">15.2 ค่าที่พัก</strong>
                </div>
                <div class="col-xs-8">
                  <span>จำนวน {{ projectProposal.plannedBudget.accommodation | numFormat('0,0.00') }} บาท ({{ projectProposal.plannedBudget.accommodation | thaibahttext }})</span>
                </div>
              </div>
              <div class="row project-info">
                <div class="col-xs-3">
                  <strong class="control-label">15.3 ค่าวัสดุโครงการ</strong>
                </div>
                <div class="col-xs-8">
                  <span>จำนวน {{ projectProposal.plannedBudget.materials | numFormat('0,0.00') }} บาท ({{ projectProposal.plannedBudget.materials | thaibahttext }})</span>
                </div>
              </div>
              <div class="row project-info">
                <div class="col-xs-3">
                  <strong class="control-label">15.4 ค่าวัสดุพาหนะไป-กลับ</strong>
                </div>
                <div class="col-xs-8">
                  <span>จำนวน {{ projectProposal.plannedBudget.transportation | numFormat('0,0.00') }} บาท ({{ projectProposal.plannedBudget.transportation | thaibahttext }})</span>
                </div>
              </div>
              <div class="row project-info">
                <div class="col-xs-3">
                  <strong class="control-label">15.5 ค่าน้ำมันเชื้อเพลิง</strong>
                </div>
                <div class="col-xs-8">
                  <span>จำนวน {{ projectProposal.plannedBudget.gas | numFormat('0,0.00') }} บาท ({{ projectProposal.plannedBudget.gas | thaibahttext }})</span>
                </div>
              </div>
              <div class="row project-info">
                <div class="col-xs-3">
                  <strong class="control-label">15.6 ค่าเช่ารถ</strong>
                </div>
                <div class="col-xs-8">
                  <span>จำนวน {{ projectProposal.plannedBudget.vehicleRental | numFormat('0,0.00') }} บาท ({{ projectProposal.plannedBudget.vehicleRental | thaibahttext }})</span>
                </div>
              </div>
              <div class="row project-info">
                <div class="col-xs-3">
                  <strong class="control-label">15.7 ค่าผ่านทางพิเศษ</strong>
                </div>
                <div class="col-xs-8">
                  <span>จำนวน {{ projectProposal.plannedBudget.tollwayFee | numFormat('0,0.00') }} บาท ({{ projectProposal.plannedBudget.tollwayFee | thaibahttext }})</span>
                </div>
              </div>
              <div class="row project-info">
                <div class="col-xs-3">
                  <strong class="control-label">15.8 ค่าเบี้ยเลี้ยงพนักงานขับรถ</strong>
                </div>
                <div class="col-xs-8">
                  <span>จำนวน {{ projectProposal.plannedBudget.driver | numFormat('0,0.00') }} บาท ({{ projectProposal.plannedBudget.driver | thaibahttext }})</span>
                </div>
              </div>
              <div class="row project-info">
                <div class="col-xs-3">
                  <strong class="control-label">15.9 ค่าตอบแทนวิทยากร</strong>
                </div>
                <div class="col-xs-8">
                  <span>จำนวน {{ projectProposal.plannedBudget.lecture | numFormat('0,0.00') }} บาท ({{ projectProposal.plannedBudget.lecture | thaibahttext }})</span>
                </div>
              </div>
              <div class="row project-info">
                <div class="col-xs-3">
                  <strong class="control-label">15.10 ค่าใช้จ่ายอื่นๆ</strong>
                </div>
                <div class="col-xs-8">
                  <span>จำนวน {{ projectProposal.plannedBudget.other | numFormat('0,0.00') }} บาท ({{ projectProposal.plannedBudget.other | thaibahttext }})</span>
                </div>
              </div>
              <div class="row project-info">
                <div class="col-xs-3">
                  <strong class="control-label">15.11 วัสดุ/อุปกรณ์/ทรัพยากร ที่ได้รับการสนับสนุนจากหน่วยงานราชการ/เอกชน (ระบุ)</strong>
                </div>
                <div class="col-xs-8">
                  <span>จำนวน {{ projectProposal.plannedBudget.sponsoredMaterials }} บาท ({{ projectProposal.plannedBudget.sponsoredMaterials | thaibahttext }})</span>
                </div>
              </div>
            </div> -->
        </div>
      </div>
      <div class="col-md-3">
        <div class="card-pf">
          <div class="card-pf-heading">
            <h2 class="card-pf-title">
              จัดการโครงการ
            </h2>
          </div>
          <div class="card-pf-body">
            <p><strong>สถานะปัจจุบัน</strong> <span class="label label-primary"><strong> {{ projectProposal.status }}</strong></span></p>
            <div class="text-center">
              <project-status :status="projectProposal.status" />
              <p class="text-center" style="margin-top: 10px"> <strong>สถานะล่าสุด</strong> : {{ projectProposal.status }}</p>
              <hr>

              <button v-if="state == 'student' && projectProposal.status == 'แบบร่าง'" class="btn btn-primary" :disabled="projectProposal.status != 'แบบร่าง'" @click.prevent="send($route.params.id)">ส่งให้อาจารย์ที่ปรึกษา</button>
              <button v-if="state == 'advisor'" class="btn btn-success" :disabled="projectProposal.status != 'รอการอนุมัติจากอาจารย์ที่ปรึกษา'" @click.prevent="pass($route.params.id)">ผ่าน</button>
              <button v-if="state == 'advisor'" class="btn btn-warning" :disabled="projectProposal.status != 'รอการอนุมัติจากอาจารย์ที่ปรึกษา'" @click.prevent="notpass($route.params.id)">ไม่ผ่าน</button>
              <button v-if="state == 'osda'" class="btn btn-success" :disabled="projectProposal.status == 'อนุมัติ' || projectProposal.status =='ไม่อนุมัติ'" @click.prevent="approve($route.params.id)">อนุมัติ</button>
              <button v-if="state == 'osda'" class="btn btn-danger" :disabled="projectProposal.status =='อนุมัติ' || projectProposal.status =='ไม่อนุมัติ'" @click.prevent="reject($route.params.id)">ไม่อนุมัติ</button>
            </div>
            <!-- แบบร่าง, ส่งแบบร่าง, รอการพิจารณาจากอาจารย์ที่ปรึกษา, รอการพิจารณาจากองค์การนักศึกษา, เรียบร้อย -->
            <hr>
            <p> <strong>เอกสาร</strong> </p>
            <div class="text-center">
              <router-link v-if="projectProposal.status == 'แบบร่าง' && (state == 'advisor' || state == 'student')" tag="a" class="btn btn-default" :to="{ name: 'projects.edit' }">
                แก้ไข
              </router-link>
              <a class="btn btn-primary" :href="`https://osda.dev.devcrew.co.th/api/pdf/project-proposal?id=${$route.params.id}`" target="_blank">
                ดาวน์โหลดเอกสาร
              </a>
              <a v-if="projectProposal.signedDoc" class="btn btn-primary" :href="`https://osda.dev.devcrew.co.th/api${projectProposal.signedDoc}`" target="_blank">
                ดาวน์โหลดเอกสารจาก OSDA
              </a>
            </div>
            <hr>
            <div v-if="state == 'osda'">
              <div class="form-group">
                <label for="exampleInputFile">อัพโหลดเอกสาร <span v-if="projectProposal.signedDoc" class="text-success">(<i class="fa fa-check-circle" /> อัพโหลดแล้ว)</span></label>
                <input type="file" accept="application/pdf" @change="selectSignedDocFile">
                <p class="help-block" style="margin-bottom: 10px">ไฟล์ .pdf เท่านั้น (กรณีที่มีการอัพโหลดเอกสารแล้ว เอกสารใหม่จะแทนที่เอกสารเก่า)</p>
                <button class="btn btn-primary btn-block" @click.prevent="uploadSignedDoc">อัพโหลดเอกสาร</button>
              </div>
            </div>
            <div v-if="state == 'student' && projectProposal.status == 'อนุมัติ'">
              <hr>
              <p> <strong>ระบบกิจกรรมสำหรับนักศึกษา</strong> </p>
              <form :action="eventUrl + 'event/create'" method="POST">
                <input type="hidden" name="token" :value="$auth.token()">
                <input type="hidden" name="projectName" :value="projectProposal.name">
                <input type="hidden" name="venue" :value="projectProposal.venue">
                <button type="submit" class="btn btn-default btn-block">สร้างกิจกรรมบนหน้าเว็บ</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import THBBaht from 'thai-baht-text'
import ProjectStatus from '../../components/projects/ProjectStatus'

export default {
  components: {
    ProjectStatus
  },
  apollo: {
    projectProposal: {
      query: gql`query projectProposal($id: ID!){
      projectProposal(_id: $id) {
        name
        status
        type
        typeCharacteristics
        venue
        attendee {
          instructor
          student
          individual
          others
        }
        advisor {
          name
          tel
        }
        heldOn
        aspectAndGoal
        objectives
        background
        responsiblePerson {
          name
          tel
        }
        budget {
          osda
          other
          sponsors
        }
        procedures
        expectedOutcome
        plannedBudget {
          meal
          accommodation
          materials
          transportation
          gas
          vehicleRental
          tollwayFee
          driver
          lecture
          other
        }
        sponsoredMaterials
        signedDoc
      }
    }`,
      variables () {
        return {
          id: this.$route.params.id
        }
      }
    }
  },
  filters: {
    thaibahttext: function (value) {
      return value ? THBBaht(value) : '-'
    }
  },
  data () {
    return {
      state: this.$auth.user().role,
      signedDocs: null
    }
  },
  computed: {
    eventUrl () {
      return process.env.EVENT_WEB_URL
    }
  },
  methods: {
    async approve (id) {
      const projectProposal = await this.$apollo.mutate({
        mutation: gql`mutation ($id: ID!, $projectProposal: EditProjectProposalInput!) {
            updateProjectProposal(_id: $id, proposal: $projectProposal) {
              _id
            }
          }`,
        variables: {
          projectProposal: {
            status: 'อนุมัติ'
          },
          id: id
        }
      })
      location.reload()
      this.$router.push({ name: 'projects.show', params: { id: projectProposal.data.updateProjectProposal._id } })
    },
    async reject (id) {
      const projectProposal = await this.$apollo.mutate({
        mutation: gql`mutation ($id: ID!, $projectProposal: EditProjectProposalInput!) {
            updateProjectProposal(_id: $id, proposal: $projectProposal) {
              _id
            }
          }`,
        variables: {
          projectProposal: {
            status: 'ไม่อนุมัติ'
          },
          id: id
        }
      })
      location.reload()
      this.$router.push({ name: 'projects.show', params: { id: projectProposal.data.updateProjectProposal._id } })
    },
    async send (id) {
      const projectProposal = await this.$apollo.mutate({
        mutation: gql`mutation ($id: ID!, $projectProposal: EditProjectProposalInput!) {
            updateProjectProposal(_id: $id, proposal: $projectProposal) {
              _id
            }
          }`,
        variables: {
          projectProposal: {
            status: 'รอการอนุมัติจากอาจารย์ที่ปรึกษา'
          },
          id: id
        }
      })
      location.reload()
      this.$router.push({ name: 'projects.show', params: { id: projectProposal.data.updateProjectProposal._id } })
    },
    async pass (id) {
      const projectProposal = await this.$apollo.mutate({
        mutation: gql`mutation ($id: ID!, $projectProposal: EditProjectProposalInput!) {
            updateProjectProposal(_id: $id, proposal: $projectProposal) {
              _id
            }
          }`,
        variables: {
          projectProposal: {
            status: 'อยู่ระหว่างการพิจารณา'
          },
          id: id
        }
      })
      location.reload()
      this.$router.push({ name: 'projects.show', params: { id: projectProposal.data.updateProjectProposal._id } })
    },
    async notpass (id) {
      const projectProposal = await this.$apollo.mutate({
        mutation: gql`mutation ($id: ID!, $projectProposal: EditProjectProposalInput!) {
            updateProjectProposal(_id: $id, proposal: $projectProposal) {
              _id
            }
          }`,
        variables: {
          projectProposal: {
            status: 'ไม่ผ่านการอนุมัติจากอาจารย์ที่ปรึกษา'
          },
          id: id
        }
      })
      location.reload()
      this.$router.push({ name: 'projects.show', params: { id: projectProposal.data.updateProjectProposal._id } })
    },
    uploadSignedDoc () {
      let payload = new FormData()
      payload.append('projectId', this.$route.params.id)
      payload.append('doc', this.signedDocs)

      this.axios.post('upload/signed-doc', payload).then(response => {
        this.$router.go()
      })
    },
    async selectSignedDocFile (event) {
      this.signedDocs = event.target.files[0]
    }
  }
}
</script>

<style lang="scss" scoped>
  .container-fluid{
    display: flex;
    flex-direction: column;
  }
  .row-flex {
    display: flex;
    height: 100vh;
  }
  .project-info {
    padding: 5px 0 5px 0;
    margin-top: 0;
    margin-bottom: 0;
    .form-info {
      background: #ececec;
      padding-top: 3px;
      padding-bottom: 3px;
    }
  }
  .control-label {
    padding-left: 50px;
  }

  .margin-button {
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/js/views/projects/Show.vue